import { useState } from 'react';
import './UploadCsvPage.css';
import { v4 as uuid4 } from 'uuid';

const API_URL = 'https://api.vouppy.com';

export default function UploadCsvPage({ userId, objectId, apiKey, organizationId }) {
  const [csvData, setCsvData] = useState([]);
  const [loading, setLoading] = useState(false);

    const allChecked =
      csvData.length > 0 && csvData.every(row => row.checked);

    const toggleCheckAll = () => {
      setCsvData(prev =>
        prev.map(row => ({
          ...row,
          checked: !allChecked
        }))
      );
    };

    const toggleRowCheck = (id) => {
      setCsvData(prev =>
        prev.map(row =>
          row.id === id
            ? { ...row, checked: !row.checked }
            : row
        )
      );
    };

  // Upload CSV - učitaj u grid
  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const text = event.target.result;
        const rows = text.split('\n').filter(row => row.trim());

        if (rows.length < 2) {
          alert('CSV fajl je prazan');
          return;
        }

        const headers = rows[0].split(',').map(h => h.trim());

        const data = rows.slice(1).map((row, index) => {
          const values = row.split(',').map(v => v.trim());
          const obj = {
            id: Date.now() + index,
            code: uuid4(),
            status: 'pending',
            checked: false
          };

          headers.forEach((header, i) => {
            obj[header] = values[i] || '';
          });

          return obj;
        });

        setCsvData(data);
        console.log(`✅ Učitano ${data.length} redova iz CSV-a`);
      } catch (err) {
        alert('Greška pri učitavanju CSV-a: ' + err.message);
      }
    };

    reader.readAsText(file);
    e.target.value = '';
  };

    const handleCreateVouchers = async () => {
      setLoading(true);

      try {
        const selectedRows = csvData.filter(r => r.checked);
        console.log('🎯 Selected rows:', selectedRows);
        console.log('🎯 Selected UUIDs:', selectedRows.map(r => r.code));
        console.log('Props check:', { userId, objectId, apiKey, organizationId });
        console.log('objectId type:', typeof objectId);
        console.log('parseInt result:', parseInt(objectId, 10));

        const vouchersPayload = selectedRows.map(row => ({
          uuid: row.code,
          user_id: parseInt(userId, 10),
          object_id: parseInt(objectId, 10),
          amount: parseFloat(row.amount),
          date_expiration: row.date_expiration,
          description: row.description,
          email: row.email || null,
          telephone: row.telephone || null
        }));

        const payload = { vouchers: vouchersPayload };
        console.log('📤 Sending payload:', payload);

        const response = await fetch(`${API_URL}/admin/create-bulk/${organizationId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Api-Key': apiKey
          },
          body: JSON.stringify(payload)
        });

        console.log('📥 Response status:', response.status);

        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          throw new Error(errData.detail || 'Greška pri kreiranju vaučera');
        }

        const result = await response.json();
        console.log('📥 Backend result:', result);
        console.log('📥 Vouchers from backend:', result.vouchers);

        if (result.vouchers && Array.isArray(result.vouchers)) {
          console.log('✅ Building status map...');

          const statusMap = new Map();
          result.vouchers.forEach(v => {
            console.log(`  Mapping: ${v.uuid} -> ${v.status}`);
            statusMap.set(v.uuid, v);
          });

          console.log('📊 Status map size:', statusMap.size);
          console.log('📊 Status map keys:', Array.from(statusMap.keys()));
          console.log('📋 Current csvData before update:', csvData);

          setCsvData(prev => {
            console.log('🔄 INSIDE setCsvData');
            console.log('  prev:', prev);
            console.log('  prev checked:', prev.filter(r => r.checked));

            const updated = prev.map((row, idx) => {
              console.log(`\n  Processing row ${idx}:`);
              console.log(`    UUID: ${row.code}`);
              console.log(`    Checked: ${row.checked}`);
              console.log(`    Current status: ${row.status}`);

              if (!row.checked) {
                console.log(`    -> Skipping (not checked)`);
                return row;
              }

              const voucherStatus = statusMap.get(row.code);
              console.log(`    Found in map: ${!!voucherStatus}`);

              if (voucherStatus) {
                console.log(`    Backend status: ${voucherStatus.status}`);
                console.log(`    -> Updating to: ${voucherStatus.status}`);
              } else {
                console.warn(`    ⚠️ NOT FOUND IN MAP!`);
              }

              if (!voucherStatus) return row;

              const updatedRow = {
                ...row,
                status: voucherStatus.status,  // 'success' ili 'failed'
                checked: false,
                error: voucherStatus.error_message || null
              };

              console.log(`    Updated row:`, updatedRow);
              return updatedRow;
            });

            console.log('\n🔄 Final updated array:', updated);
            console.log('🔄 Updated statuses:', updated.map(r => ({ code: r.code, status: r.status })));
            return updated;
          });

          console.log('✅ setCsvData executed');

          if (result.successful > 0 && result.failed === 0) {
            alert(`✅ Uspešno kreirano ${result.successful} vaučera`);
          } else if (result.successful > 0 && result.failed > 0) {
            alert(`⚠️ Kreirano ${result.successful} vaučera, ${result.failed} neuspešno`);
          } else {
            alert(`❌ Kreiranje nije uspelo za ${result.failed} vaučera`);
          }

          // Proveri csvData nakon nekog vremena
          setTimeout(() => {
            console.log('⏰ csvData after 1 second:', csvData);
          }, 1000);

        } else {
          console.error('❌ No vouchers in result or not an array');
        }

      } catch (err) {
        console.error('❌ Error:', err);
        alert('❌ Greška: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

  return (
    <div className="upload">
      <h2>📤 Kreiranje poklon vaučera (CSV)</h2>

      <div className="upload-box">
        <input
          type="file"
          accept=".csv"
          onChange={handleUpload}
          disabled={loading}
        />
        <p className="upload-hint">
          CSV mora imati header (amount, email, telephone…)
        </p>
      </div>

      {csvData.length > 0 && (
        <>
          <h3 style={{ marginTop: 30 }}>
            Pregled podataka ({csvData.length})
          </h3>

          <div className="table-container">
            <table className="table">
                <thead>
                  <tr>
                    <th style={{ width: 140 }}>
                      <button
                        onClick={toggleCheckAll}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#007bff',
                          cursor: 'pointer',
                          fontWeight: 'bold'
                        }}
                      >
                        {allChecked ? 'Raščekiraj sve' : 'Čekiraj sve'}
                      </button>
                    </th>

                    <th>Kod</th>

                    {Object.keys(csvData[0])
                      .filter(k => !['id', 'code', 'status', 'checked'].includes(k))
                      .map(h => <th key={h}>{h}</th>)}

                    <th>Status</th>
                    <th>Napomena</th>
                  </tr>
                </thead>

                <tbody>
                  {csvData.map(row => (
                      <tr
                        key={row.id}
                        style={{
                          backgroundColor: row.status === 'success'
                            ? '#e8f5e9'  // Svetlo zelena za uspešne
                            : row.checked
                            ? '#f1f7ff'  // Plava za označene
                            : 'transparent',
                          opacity: row.status === 'success' ? 0.7 : 1  // Bledi uspešne redove
                        }}
                      >
                      <td>
                        <input
                          type="checkbox"
                          checked={row.checked}
                          disabled={row.status === 'success'}  // ✅ Onemogući ako je uspešno kreiran
                          onChange={() => toggleRowCheck(row.id)}
                          style={{
                            cursor: row.status === 'success' ? 'not-allowed' : 'pointer',
                            opacity: row.status === 'success' ? 0.5 : 1
                          }}
                        />
                      </td>

                      <td>
                        {row.code
                          ? <span>{row.code}</span>
                          : <span>⏳</span>}
                      </td>

                      {Object.keys(row)
                        .filter(k => !['id', 'code', 'status', 'checked', 'error'].includes(k))  // ✅ Dodaj 'error' u filter
                        .map(k => (
                          <td key={k}>{row[k]}</td>
                        ))}

                      <td>
                        {row.status === 'success'
                          ? '✅ Kreirano'
                          : row.status === 'failed'
                          ? '❌ Neuspelo'
                          : '⏳ Čeka se'}
                      </td>

                      <td style={{ color: '#d32f2f', fontSize: '0.9em' }}>  {/* ✅ Dodaj na kraju */}
                        {row.error || '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>

            </table>
          </div>

            <button
              onClick={handleCreateVouchers}
              disabled={loading || csvData.filter(r => r.checked && r.status === 'pending').length === 0}
              style={{
                marginTop: 20,
                padding: 14,
                width: '100%',
                fontWeight: 'bold',
                cursor: loading || csvData.filter(r => r.checked && r.status === 'pending').length === 0 ? 'not-allowed' : 'pointer'
              }}
            >
              {loading ? '⏳ Kreiram...' : '✅ Kreiraj odabrane vaučere'}
            </button>
        </>
      )}
    </div>
  );
}
